import { useCallback, useEffect, useState } from "react";

const KEY = "open-wrecks:theme";

const stored = () => {
  try { const t = localStorage.getItem(KEY); return t === "dark" || t === "light" ? t : null; } catch { return null; }
};
const systemTheme = () =>
  window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

// "light" | "dark". Follows the OS until the person clicks the toggle, then remembers their choice.
// public/index.html sets data-theme before React loads so the page never flashes the wrong colours.
export default function useTheme() {
  const [theme, setTheme] = useState(() => stored() || systemTheme());

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", theme === "dark" ? "#10181b" : "#ffffff");
  }, [theme]);

  // track OS changes while the person hasn't chosen
  useEffect(() => {
    if (!window.matchMedia) return;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = () => { if (!stored()) setTheme(systemTheme()); };
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const toggle = useCallback(() => {
    setTheme((t) => {
      const next = t === "dark" ? "light" : "dark";
      try { localStorage.setItem(KEY, next); } catch {}
      return next;
    });
  }, []);

  return [theme, toggle];
}
